export default () => ({
	isOpen: false,

	bridge: {},
	open(value) {
		this.isOpen = value;
		if (this.onModalOpen) {
			this.onModalOpen(value);
		}
	},
	onModalOpen: () => { },
	idListeners: (modalid) =>
		modalid
			? {
				['@modalopenid.window']() {
					if (this.$event.detail.modalid === modalid) {
						this.open(true);
					}
				},
				['@modalcloseid.window']() {
					if (this.$event.detail.modalid === modalid) {
						this.open(false);
					}
				},
			}
			: {},
});
